module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Crema_Cacahuate.880b4ef0.pdf";